import type { CopyCheckFinding, CopyCheckRule } from '../types/api';

/** Rule names in the user's words. The wire value is the data, not the label. */
const COPY_RULE_LABEL: Readonly<Record<CopyCheckRule, string>> = {
  never_say: 'Words to avoid',
  char_limit: 'Character limit',
  pii_email: 'Email address',
  pii_phone: 'Phone number',
  emoji: 'Emoji',
  dash: 'Dash',
  length_target: 'Outside the length you asked for',
};

/**
 * Hits from the deterministic copy guardrails, rendered the same way wherever
 * copy is checked — the knowledge base's bench and the caption editor on both
 * review steps.
 *
 * Severity carries the colour and nothing else: this list reports, it never
 * decides. Whether a `fail` blocks a save is the caller's rule, because only
 * the caller knows what the save would do.
 */
export function CopyFindingList({ findings }: { findings: CopyCheckFinding[] }) {
  if (findings.length === 0) return null;

  return (
    <ul className="finding-list">
      {findings.map((finding) => (
        <li
          className={`finding finding--${finding.severity}`}
          key={`${finding.rule}-${finding.start}-${finding.end}`}
        >
          <div className="finding__head">
            <span className="finding__severity">
              {finding.severity === 'fail' ? 'Fail' : 'Warn'}
            </span>
            <span className="finding__rule">{COPY_RULE_LABEL[finding.rule]}</span>
          </div>
          <p className="finding__message">{finding.message}</p>
          {finding.matched_text ? <p className="finding__match">{finding.matched_text}</p> : null}
        </li>
      ))}
    </ul>
  );
}
